<template>
    <div>
        <div class="top-title-content">
            <span class="title">락커내역</span>
            <span class="txt">
                회원에게 락커를 대여하고, 회수할 수 있습니다. 또한 대여중인 락커의 이용기간을 변경하여 등록할 수
                있습니다. 락커자체의 기본설정 (락커의 이름과
                <br />
                금액 책정방식)을 변경하시려면
                <span class="blue">설정 &gt; 센터설정 &gt; 락커</span>
                메뉴를 이용해주세요.
            </span>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="top-locker-content">
                <ul>
                    <li v-for="(l, index) in lockerGroupList" :key="index" @click="onClickLockerGroup(l)">
                        <span :class="{ icon: true, red: l.p_use_yn === false }">
                            {{ l.p_use_yn === true ? '사용중' : '미사용' }}
                        </span>
                        <span class="txt">{{ l.p_namee }}</span>
                        <span class="detail">
                            {{ convertLockerSex(l.p_lock_sex) }} / {{ l.p_lock_no_range_start }}-{{
                                l.p_lock_no_range_end
                            }}
                        </span>
                        <span v-if="l.p_lock_fix_price_yn === true" class="info">1개월 고정금액</span>
                        <span v-else class="info">개월별 차등금액</span>
                    </li>
                </ul>
            </div>

            <div class="com-search-content">
                <div class="line">
                    <div class="com-radio">
                        <input
                            id="radio-day-1"
                            :checked="checkType == 'C'"
                            name="radio-day"
                            type="radio"
                            @click="searchRadio('C')"
                        />
                        <label class="w110" for="radio-day-1">등록일 조회</label>
                    </div>
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="['오늘', '어제', '이번 달', '지난 달', '3개월', '6개월', '12개월', '전체']"
                        :select-value="[
                            'today',
                            'yesterday',
                            'thisMonth',
                            'prevMonth',
                            'threeMonth',
                            'sixMonth',
                            'year',
                            '',
                        ]"
                        :selected-value="period"
                        @update:set="(val) => periodc(val)"
                    ></select-form>
                    <div class="com-search-input">
                        <input
                            v-model="searchStr"
                            placeholder="이름 입력"
                            type="text"
                            v-on:keyup.enter="onEventSearch"
                        />
                        <button class="search-btn" @click="onEventSearch">검색</button>
                    </div>
                </div>
                <div class="line">
                    <div class="com-radio">
                        <input
                            id="radio-day-2"
                            :checked="checkType == 'E'"
                            name="radio-day"
                            type="radio"
                            @click="searchRadio('E')"
                        />
                        <label class="w110" for="radio-day-2">만료일 조회</label>
                    </div>
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="expireStartDt" @update="expStartDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="expireEndDt" @update="expEndDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="[
                            '오늘',
                            '만료 1일 전',
                            '만료 3일 전',
                            '만료 7일 전',
                            '이번 달',
                            '지난 달',
                            '전체',
                        ]"
                        :select-value="['today', '1', '3', '7', 'thisMonth', 'prevMonth', '']"
                        :selected-value="periodExp"
                        @update:set="(val) => periodExpc(val)"
                    ></select-form>
                    <span class="tit red right">* 락커번호로 조회 및 검색이 가능합니다.</span>
                </div>
            </div>
            <loading-spinner v-if="lockerListIsLoading"></loading-spinner>
            <div v-else class="locker-view-content">
                <ul>
                    <li v-for="(l, index) in lockerGroupDetailList" :key="index">
                        <template
                            v-if="
                                (l.locker_status === '-' && l.upd_nm != 'batch') ||
                                (l.locker_status === '-' && l.upd_nm == 'batch' && l.rent_cust_nm == null) ||
                                l.locker_status === 'F'
                            "
                        >
                            <!-- 미사용, 회수완료 락커 -->
                            <span class="num">{{ l.locker_no }}</span>
                            <span
                                class="select-txt"
                                @click="onClickLockerInfoForEdit(l.locker_no, l.rent_cust_id, l)"
                            >
                                선택가능
                                <br />
                                <span v-if="l.pw" style="font-size: 12px">비밀번호: {{ l.pw }}</span>
                            </span>
                        </template>
                        <template
                            v-else-if="
                                l.locker_status === 'U' ||
                                l.locker_status === 'E' ||
                                l.locker_status === 'R' ||
                                (l.locker_status === '-' && l.upd_nm == 'batch' && l.rent_cust_nm != null)
                            "
                        >
                            <!-- 사용중, 종료 락커 -->
                            <span class="num">{{ l.locker_no }}</span>
                            <div class="btn-cnt">
                                <button class="msg"><span class="blind">문자보내기</span></button>
                                <button
                                    class="change"
                                    @click="onClickLockerMove(l.center_id, l.center_prod_id, l.locker_no)"
                                >
                                    <span class="blind">옮기기</span>
                                </button>
                                <button
                                    class="del"
                                    @click="onClickLockerDelete(l.center_id, l.center_prod_id, l.locker_no)"
                                >
                                    <span class="blind">삭제하기</span>
                                </button>
                            </div>
                            <div class="info" @click="onClickLockerInfoForEdit(l.locker_no, l.rent_cust_id, l)">
                                <span class="name">
                                    {{ l.cust_nm }}
                                    <span v-if="l.pw" style="font-size: 12px">비밀번호 : {{ l.pw }}</span>
                                </span>
                                <div class="line">
                                    <span :class="{ icon: true, red: l.locker_status === 'E' }">
                                        {{ convertLockerStatus(l.locker_status) }}
                                    </span>
                                    <span
                                        :class="{
                                            expire: true,
                                            blue: calcRemainDays(l.rent_end_dt) < 0,
                                            red: calcRemainDays(l.rent_end_dt) > 0,
                                        }"
                                    >
                                        만료{{ calcRemainDays(l.rent_end_dt) }}
                                    </span>
                                    <span v-if="l.rent_start_dt !== null && l.rent_end_dt !== null" class="day">
                                        {{ l.rent_start_dt | timestampFilter }} ~
                                        {{ l.rent_end_dt | timestampFilter }}
                                    </span>
                                </div>
                            </div>
                        </template>
                    </li>
                </ul>
            </div>
            <b-pagination
                v-model="lockerGroupDetailPagingInfo.page"
                :per-page="lockerGroupDetailPagingInfo.limit"
                :total-rows="lockerGroupDetailPagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            />

            <!-- 락커이동 팝업 -->
            <div v-if="lockerMovePop && selectedLockerDetail" class="layer-pop square-type">
                <div class="view-content w655">
                    <button class="close" @click="onClickCloseLockerMovePop">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <loading-spinner v-if="lockerMovePopIsLoading"></loading-spinner>
                    <div v-else class="scroll-area com-scroll-y">
                        <span class="sub-title">
                            락커이동
                            <span class="info-txt">{{ selectedLockerDetail.lockerNo }}번</span>
                        </span>
                        <p class="sub-txt">사용 중인 락커를 이동 하시겠습니까?</p>
                        <table class="com-table left no-border">
                            <colgroup>
                                <col style="width: 135px" />
                                <col style="width: 465px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>센터</th>
                                    <td>{{ centerInfo.centerName }}</td>
                                </tr>
                                <tr>
                                    <th>락커구분</th>
                                    <td>{{ selectedLockerDetail.lockerGroupName }}</td>
                                </tr>
                                <tr>
                                    <th>성별</th>
                                    <td>{{ convertLockerSex(selectedLockerDetail.sex) }}</td>
                                </tr>
                                <tr>
                                    <th>락커번호</th>
                                    <td>
                                        <select-form
                                            :select-data="['선택', ...emptyLockerNoList]"
                                            :select-value="['', ...emptyLockerNoValueList]"
                                            class="w265"
                                            @update:set="(val) => (selectedLockerDetail.newLockerNo = val)"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>회원명</th>
                                    <td>{{ selectedLockerDetail.rentCustomerName }}</td>
                                </tr>
                                <tr>
                                    <th>기간</th>
                                    <td>
                                        {{ selectedLockerDetail.rentStartedAt }} ~
                                        {{ selectedLockerDetail.rentEndedAt }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>금액</th>
                                    <td>
                                        {{ selectedLockerDetail.rentMonth }}개월 -
                                        {{ selectedLockerDetail.rentBillPrice | numberFormatFilter }}원
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCloseLockerMovePop">취소</button>
                            <button class="com-btn blue" @click="onClickLockerMoveSave">이동</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 락커회수 삭제 팝업 -->
            <div v-if="lockerDelPop && selectedLockerDetail" class="layer-pop square-type">
                <div class="view-content w655">
                    <button class="close" @click="onClickCloseLockerDelPop">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <loading-spinner v-if="lockerDelPopIsLoading"></loading-spinner>
                    <div v-else class="scroll-area com-scroll-y">
                        <span class="sub-title">
                            락커회수
                            <span class="info-txt">{{ selectedLockerDetail.lockerNo }}번</span>
                        </span>
                        <p class="sub-txt">사용 중인 락커를 삭제 하시겠습니까?</p>
                        <table class="com-table left no-border">
                            <colgroup>
                                <col style="width: 135px" />
                                <col style="width: 465px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>센터</th>
                                    <td>{{ centerInfo.centerName }}</td>
                                </tr>
                                <tr>
                                    <th>락커구분</th>
                                    <td>{{ selectedLockerDetail.lockerGroupName }}</td>
                                </tr>
                                <tr>
                                    <th>성별</th>
                                    <td>{{ convertLockerSex(selectedLockerDetail.sex) }}</td>
                                </tr>
                                <tr>
                                    <th>락커번호</th>
                                    <td>{{ selectedLockerDetail.lockerNo }}</td>
                                </tr>
                                <tr>
                                    <th>회원명</th>
                                    <td>{{ selectedLockerDetail.rentCustomerName }}</td>
                                </tr>
                                <tr>
                                    <th>대여기간</th>
                                    <td>
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :start-date="selectedLockerDetail.rentStartedAt"
                                                class="w150"
                                                disabled
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="selectedLockerDetail.rentEndedAt"
                                                class="w150"
                                                disabled
                                            ></single-calendar>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>금액</th>
                                    <td>
                                        {{ selectedLockerDetail.rentMonth }}개월 -
                                        {{ selectedLockerDetail.rentBillPrice | numberFormatFilter }}원
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="red">회수날짜</span></th>
                                    <td>
                                        <single-calendar
                                            :date="this.today"
                                            :disabled="true"
                                            class="w150"
                                        ></single-calendar>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCloseLockerDelPop">취소</button>
                            <button
                                class="com-btn blue"
                                @click="
                                    onClickLockerExtend(
                                        selectedLockerDetail.lockerNo,
                                        selectedLockerDetail.rentCustomerId
                                    )
                                "
                            >
                                연장
                            </button>
                            <button class="com-btn blue" @click="onClickLockerReturn">회수</button>
                            <button class="com-btn blue" @click="onClickLockerReturnDelete">삭제</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import moment from 'moment';
import { timestampToDate } from '@/assets/js/excelCommon.js';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'MemberLocker',
    mixins: [MixinAllowedMenu],
    components: { LoadingSpinner },
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
        today() {
            return moment().format('YYYY-MM-DD');
        },
    },
    mounted() {
        this.goMainIfNotAllowed('MB', 6);
        this.init();
    },
    data() {
        return {
            advicePop: false,
            lockerMovePop: false,
            lockerDelPop: false,
            isLoading: false,
            lockerListIsLoading: false,
            lockerMovePopIsLoading: false,
            lockerDelPopIsLoading: false,
            startDate: moment().subtract(12, 'months').format('YYYY-MM-DD'),
            endDate: (this.endDate = moment().format('YYYY-MM-DD')),
            expireStartDt: moment().startOf('month').format('YYYY-MM-DD'),
            expireEndDt: moment().endOf('month').format('YYYY-MM-DD'),
            period: 'year', // 등록일 조회
            periodExp: 'thisMonth', // 만료일 조회
            checkType: '', // 기본값 C

            centerInfo: {},
            lockerGroupList: [],
            lockerGroupDetailList: [],

            selectedLockerDetail: {
                rentReturnedAt: this.today,
            },

            emptyLockerNoList: [], // 비어 있는 락커 번호 목록
            emptyLockerNoValueList: [], // 비어 있는 락커 번호 목록

            lockerGroupDetailPagingInfo: {
                totalItems: 999999,
                page: { ...pagingInfo.page },
            },
            currentPage: 100,
            pagingInfo: { ...pagingInfo },
            selectedCenterId: '',
            selectedCenterProductId: '',
            selectedCenterProductVersion: '',

            searchStr: '', // 이름으로 락커 찾을때 파라미터
            searchLockerNo: '', // 락커번호로 락커 찾을때 파라미터
            curLockerGroup: {},
        };
    },
    methods: {
        async init() {
            // 초기화
            this.isLoading = true;
            this.pagingInfo.page = this.$route.query.page || 1;
            this.lockerGroupDetailPagingInfo.page = this.$route.query.page || 1;
            this.lockerGroupDetailPagingInfo.limit = 20;
            this.selectedLockerDetail.rentReturnedAt = this.today;
            await this.fetchLockerGroupList(); // 락커 그룹 목록 조회
            await this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            this.isLoading = false;
            if (this.lockerGroupList.length > 0) {
                const { p_center_id, p_center_prod_id, p_center_prod_ver } = this.lockerGroupList[0];
                this.curLockerGroup = this.lockerGroupList[0];

                this.selectedCenterId = p_center_id;
                this.selectedCenterProductId = this.$route.query.productId || p_center_prod_id;
                this.selectedCenterProductVersion = p_center_prod_ver;
                await this.fetchLockerGroupDetailList(this.centerId, this.selectedCenterProductId); // 첫번째 락커그룹 목록을 띄움
            }
            // 잠시 주석...
            // await this.$router.replace({
            //     replace: true,
            //     query: {
            //         productId: this.selectedCenterProductId,
            //         page: this.lockerGroupDetailPagingInfo.page,
            //     },
            // });
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 락커 그룹 목록 가져오기
        async fetchLockerGroupList() {
            try {
                const { data } = await this.sendGetLockerGroup();
                this.lockerGroupList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 락커 그룹 목록 조회 API 호출
        sendGetLockerGroup() {
            return api.get(`/admin/api/locker/group/${this.centerId}`, {
                params: {
                    page: 1,
                    limit: 1000,
                },
            });
        },

        // 락커 성별 변환
        convertLockerSex(sex) {
            if (sex === '-') {
                return '공통';
            } else if (sex === 'M') {
                return '남성';
            } else if (sex === 'W') {
                return '여성';
            }
        },

        // 락커 그룹 클릭시
        // async onClickLockerGroup(centerId, centerProductId, centerProductVersion, index) {
        async onClickLockerGroup(lockerGroup) {
            // .p_center_id, l.p_center_prod_id, l.p_center_prod_ver, index

            const centerId = lockerGroup.p_center_id;
            const centerProductId = lockerGroup.p_center_prod_id;
            const centerProductVersion = lockerGroup.p_center_prod_ver;

            this.curLockerGroup = lockerGroup;

            this.lockerListIsLoading = true;
            this.selectedCenterId = centerId;
            this.selectedCenterProductId = centerProductId;
            this.selectedCenterProductVersion = centerProductVersion;
            this.searchStr = '';
            this.searchLockerNo = '';
            this.checkType = '';
            this.lockerGroupDetailPagingInfo.page = 1;
            await this.fetchLockerGroupDetailList(centerId, centerProductId);
            this.lockerListIsLoading = false;

            await this.$router.replace({
                query: {
                    productId: this.selectedCenterProductId,
                    page: this.lockerGroupDetailPagingInfo.page,
                },
            });
        },

        // 락커 그룹 상세 목록 가져오기
        async fetchLockerGroupDetailList(centerId, centerProductId) {
            try {
                this.emptyLockerNoList = []; // 비어 있는 락커 목록 초기화
                this.emptyLockerNoValueList = []; // 비어 있는 락커 목록 초기화

                const { data } = await this.sendGetLockerGroupDetail(centerId, centerProductId);
                this.setPageParams(data);
                this.lockerGroupDetailList = data.items;

                await this.fetchLockerGroupDetaiAll(centerId, centerProductId);
            } catch (error) {
                console.log(error);
            }
        },

        async fetchLockerGroupDetaiAll(centerId, centerProductId) {
            try {
                const { data } = await this.sendGetLockerGroupDetailAll(centerId, centerProductId);

                data.forEach((g) => {
                    if (g.locker_status !== 'U') {
                        this.emptyLockerNoList.push(g.locker_no);
                        this.emptyLockerNoValueList.push(g.locker_no);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 락커 그룹 상세 조회 API 호출
        sendGetLockerGroupDetail(centerId, centerProductId) {
            // 검색어 없으면 1페이지 검색
            if (!!this.searchStr || !!this.searchLockerNo) {
                this.lockerGroupDetailPagingInfo.page = 1;
            }
            return api.get(`/admin/api/locker/groupDetail/${centerId}`, {
                params: {
                    ...this.lockerGroupDetailPagingInfo,
                    searchStr: this.searchStr,
                    searchLockerNo: this.searchLockerNo,
                    createStartDate: this.checkType === 'C' ? moment(this.startDate).format('YYYYMMDD') : '',
                    createEndDate: this.checkType === 'C' ? moment(this.endDate).format('YYYYMMDD') : '',
                    expireStartDt: this.checkType === 'E' ? moment(this.expireStartDt).format('YYYYMMDD') : '',
                    expireEndDt: this.checkType === 'E' ? moment(this.expireEndDt).format('YYYYMMDD') : '',
                    centerProductId,
                },
            });
        },

        // 락커 그룹 모든 락커 리스트 조회 API 호출
        sendGetLockerGroupDetailAll(centerId, centerProductId) {
            return api.get(`/admin/api/locker/groupDetailAll/${centerId}`, {
                params: {
                    ...this.lockerGroupDetailPagingInfo,
                    centerProductId,
                },
            });
        },

        // 락커 상태 변환
        convertLockerStatus(status) {
            if (status === '-') {
                return '미사용';
            } else if (status === 'U') {
                return '사용중';
            } else if (status === 'R') {
                return '예약';
            } else if (status === 'E') {
                return '종료';
            }
        },

        // 락커 이동 버튼 클릭시
        onClickLockerMove(centerId, centerProductId, lockerNo) {
            this.lockerMovePop = true;
            this.fetchCenterLockerDetail(centerId, centerProductId, lockerNo);
        },

        // 락커 이동 팝업 닫기 클릭시
        onClickCloseLockerMovePop() {
            this.lockerMovePop = false;
            this.selectedLockerDetail = {
                rentReturnedAt: this.today,
            };
        },

        // 락커 번호로 락커 상세 정보 가져오기
        async fetchCenterLockerDetail(centerId, centerProductId, lockerNo) {
            try {
                this.lockerMovePopIsLoading = true;
                this.lockerDelPopIsLoading = true;
                const { data } = await this.sendGetCenterLockerDetail(centerId, centerProductId, lockerNo);
                this.selectedLockerDetail = data;
                this.lockerMovePopIsLoading = false;
                this.lockerDelPopIsLoading = false;
            } catch (error) {
                alert('락커 상세 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 락커 상세정보 조회 API 호출
        sendGetCenterLockerDetail(centerId, centerProductId, lockerNo) {
            return api.get(`/admin/api/locker/detail/${centerId}/${centerProductId}/${lockerNo}`);
        },

        // 락커 이동 팝업에서 이동 버튼 클릭시
        async onClickLockerMoveSave() {
            if (!this.selectedLockerDetail.hasOwnProperty('newLockerNo')) {
                alert('락커번호를 선택하세요.');
                return false;
            }

            if (!confirm('락커를 이동하시겠습니까?')) {
                return false;
            }

            try {
                this.lockerMovePopIsLoading = true;
                await this.sendPutLockerMove();
                alert('락커를 이동했습니다.');
                this.lockerMovePopIsLoading = false;
                this.lockerMovePop = false;
                await this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
                // alert('락커 이동 중 오류가 발생했습니다.');
                this.lockerMovePop = false;
                console.log(error);
            }
        },

        // 락커 이동 API 호출
        sendPutLockerMove() {
            const params = this.getLockerMoveParams();
            return api.put('/admin/api/locker/move', {
                ...params,
            });
        },

        // 락커 이동 파라미터 가공
        getLockerMoveParams() {
            const { selectedLockerDetail } = this;
            const params = {
                centerId: selectedLockerDetail.centerId,
                centerProductId: selectedLockerDetail.centerProductId,
                curLockerNo: selectedLockerDetail.lockerNo,
                newLockerNo: selectedLockerDetail.newLockerNo,
                customerId: selectedLockerDetail.rentCustomerId,
                customerName: selectedLockerDetail.rentCustomerName,
            };
            return params;
        },

        // 페이징 Param 설정
        setPageParams(data) {
            this.lockerGroupDetailPagingInfo.totalPages = data.meta.totalPages;
            this.lockerGroupDetailPagingInfo.totalItems = data.meta.totalItems;
            this.lockerGroupDetailPagingInfo.itemCount = data.meta.itemCount;
            this.lockerGroupDetailPagingInfo.page = data.meta.currentPage;
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.lockerGroupDetailPagingInfo.page = event;
            /*
            this.$router.replace({
                query: { page: event, productId: this.selectedCenterProductId },
                replace: true,
            });
            */
            this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
            this.scrollToTop();
        },

        // 검색어 입력
        onEventSearch(e) {
            /*
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            */

            // 숫자일 경우, 락커번호로 전달
            if (Number(this.searchStr) > 0) {
                this.searchLockerNo = Number(this.searchStr);
                this.searchStr = '';
            } else {
                this.searchLockerNo = '';
            }

            this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
        },

        // 락커 휴지통 버튼 클릭시
        async onClickLockerDelete(centerId, centerProductId, lockerNo) {
            await this.fetchCenterLockerDetail(centerId, centerProductId, lockerNo);

            // 회수날짜를 오늘날짜로 입력
            if (Utils.isEmpty(this.selectedLockerDetail.rentReturnedAt)) {
                this.selectedLockerDetail.rentReturnedAt = this.today;
            }

            this.lockerDelPop = true;
        },

        // 락커 삭제 팝업 닫기 버튼 클릭시
        onClickCloseLockerDelPop() {
            this.lockerDelPop = false;
            this.selectedLockerDetail = {
                rentReturnedAt: this.today,
            };
        },

        // 락커 회수 버튼 클릭시
        async onClickLockerReturn() {
            try {
                this.lockerDelPopIsLoading = true;
                await this.sendPutLockerReturn();

                alert('락커를 회수했습니다.');

                this.lockerDelPopIsLoading = false;
                this.lockerDelPop = false;

                await this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
            } catch (error) {
                alert('락커 회수 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        async onClickLockerReturnDelete() {
            try {
                this.lockerDelPopIsLoading = true;
                await this.sendDeleteLockerReturn();

                alert('락커를 삭제했습니다.');

                this.lockerDelPopIsLoading = false;
                this.lockerDelPop = false;

                await this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
            } catch (error) {
                alert('락커 삭제A 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 락커 회수 API 호출
        sendPutLockerReturn() {
            const params = {
                centerId: this.selectedLockerDetail.centerId,
                centerProductId: this.selectedLockerDetail.centerProductId,
                curLockerNo: this.selectedLockerDetail.lockerNo,
                rentReturnedAt: this.today,
            };
            return api.put('/admin/api/locker/return', {
                ...params,
            });
        },
        sendDeleteLockerReturn() {
            return api.post('/admin/api/locker/return/del', {
                centerId: this.selectedLockerDetail.centerId,
                centerProductId: this.selectedLockerDetail.centerProductId,
                curLockerNo: this.selectedLockerDetail.lockerNo,
                rentReturnedAt: this.today,
            });
        },

        // 락커 만료 일자 계산
        calcRemainDays(endDt) {
            const ed = moment(timestampToDate(endDt), 'YYYY-MM-DD');
            const currentDate = moment().startOf('day');
            const remainDays = moment.duration(ed.diff(currentDate)).asDays();
            return remainDays >= 0 ? `-${remainDays}` : String(remainDays).replace('-', '+');
        },

        // 락커 클릭시 결제 수정, 등록화면으로 이동
        onClickLockerInfoForEdit(lockerNo, customerId, locker) {
            if (!locker.use_yn && (locker.locker_status === '-' || locker.locker_status === 'F')) {
                alert('미사용중인 락커는 등록할 수 없습니다.');
                return false;
            }

            const query = {
                productId: this.selectedCenterProductId,
            };

            if (!Utils.isEmpty(customerId)) {
                query.customerId = customerId;
            }

            this.$router.push({ path: `/madmin/member/locker/edit/${lockerNo}`, query });

            /*
            if (customerId === null) {
                this.$router.push({ path: `/madmin/member/locker/edit/${lockerNo}` });
            } else {
                this.$router.push({ path: `/madmin/member/locker/edit/${lockerNo}`, query: { customerId } });
            }
             */
        },

        // 락커 회수 팝업에서 연장 버튼 클릭시
        async onClickLockerExtend(lockerNo, customerId) {
            if (!confirm('락커를 연장하시겠습니까?')) {
                return false;
            }

            try {
                // this.lockerDelPopIsLoading = true;
                // await this.sendPutLockerReturn();
                // this.lockerDelPopIsLoading = false;

                const query = {
                    customerId,
                    productId: this.selectedCenterProductId,
                    add: true,
                };

                await this.$router.push({ path: `/madmin/member/locker/edit/${lockerNo}`, query });
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        periodc(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.startDate = '2020-01-01';
                this.endDate = moment().format('YYYY-MM-DD');
            }
        },
        periodExpc(newValue) {
            this.periodExp = newValue;
            if (newValue === 'thisMonth') {
                this.expireStartDt = moment().startOf('month').format('YYYY-MM-DD');
                this.expireEndDt = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.expireStartDt = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.expireEndDt = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().format('YYYY-MM-DD');
            } else if (newValue === '1') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().add(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === '3') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().add(2, 'days').format('YYYY-MM-DD');
            } else if (newValue === '7') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().add(6, 'days').format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.expireStartDt = '2020-01-01';
                this.expireEndDt = moment().format('YYYY-MM-DD');
            }
        },
        searchRadio(parameter) {
            this.checkType = parameter;
            this.lockerGroupDetailPagingInfo.page = 1;
            this.onEventSearch();
            // this.init();
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.pagingInfo.page = 1;
            this.onEventSearch();
        },
        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.pagingInfo.page = 1;
            this.onEventSearch();
        },
        // 유효기간 검색 시작일 변경 event
        expStartDateUpdate(val) {
            this.expireStartDt = val;
            this.pagingInfo.page = 1;
            this.onEventSearch();
        },
        // 유효기간 검색 종료일 변경 event
        expEndDateUpdate(val) {
            this.expireEndDt = val;
            this.pagingInfo.page = 1;
            this.onEventSearch();
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },
};
</script>
<style lang="scss" scoped>
span.icon.red {
    border: 2px solid #f64444 !important;
    color: #f64444 !important;
}
</style>
